import { render, staticRenderFns } from "./ramadanCategoryDetail.vue?vue&type=template&id=282f9e94&scoped=true"
import script from "./ramadanCategoryDetail.vue?vue&type=script&lang=js"
export * from "./ramadanCategoryDetail.vue?vue&type=script&lang=js"
import style0 from "./ramadanCategoryDetail.vue?vue&type=style&index=0&id=282f9e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f9e94",
  null
  
)

export default component.exports